import { Outlet, createFileRoute } from '@tanstack/react-router';
import { guardSection } from '../../shell/guard.ts';

// Checklists section (T28, plan §9): the overview, each checklist's runs and each run share the
// gate (checklist.read: every role; attesters see only their own checklists, filtered by the API).
export const Route = createFileRoute('/_authed/checklists')({
  beforeLoad: guardSection('/checklists'),
  component: Outlet,
});
